import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { WorkspaceFileUserStatus } from '@common/workspace/enums/workspace-file-user-status.enum';
import { WorkspaceFileUser } from '@common/workspace/models/workspace-file-user.model';
import { WorkspaceFile } from '@common/workspace/models/workspace-file.model';
import { CurrentService } from '@portal-core/current/services/current.service';

export interface WorkspaceFileUserStatusListUpdateEvent {
  status: WorkspaceFileUserStatus;
  workspaceFile: WorkspaceFile;
}

@Component({
  selector: 'mc-workspace-file-user-status-list',
  templateUrl: './workspace-file-user-status-list.component.html',
  styleUrls: ['./workspace-file-user-status-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkspaceFileUserStatusListComponent {
  @Input() licenseId: number;
  @Input() workspaceFile: WorkspaceFile;
  @Input() truncateButtonClass?: string;
  @Input() truncateButtonColor?: string = 'secondary-invert';
  @Input() showStatusUpdateButton?: boolean = true;
  @Input() disabled?: boolean = false;

  @Output() updateWorkspaceFileUserStatus: EventEmitter<WorkspaceFileUserStatusListUpdateEvent> = new EventEmitter<WorkspaceFileUserStatusListUpdateEvent>();

  WorkspaceFileUserStatus: typeof WorkspaceFileUserStatus = WorkspaceFileUserStatus;

  allUsersAreDoneInMoreMenu: boolean;
  currentUserId: string;
  currentWorkspaceFileUser: WorkspaceFileUser;
  truncateEndIndex: number;
  truncateList: boolean;
  workspaceFileUsers: WorkspaceFileUser[];
  workspaceFiles: WorkspaceFile[];

  constructor(private currentService: CurrentService) {
    this.currentUserId = this.currentService.getUserId();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.workspaceFile) {
      if (this.workspaceFile?.userStatuses?.length > 0) {
        this.currentWorkspaceFileUser = this.workspaceFile.userStatuses?.find(userStatus => userStatus.userId === this.currentUserId);
        this.workspaceFileUsers = this.workspaceFile.userStatuses?.filter(userStatus => userStatus.userId !== this.currentUserId);
        this.workspaceFiles = [this.workspaceFile];
        this.truncateList = this.workspaceFile.userStatuses?.length > 3;
        this.truncateEndIndex = 3 - (this.currentWorkspaceFileUser ? 1 : 0);
        this.allUsersAreDoneInMoreMenu = this.workspaceFileUsers.slice(this.truncateEndIndex).every(userStatus => userStatus.status === WorkspaceFileUserStatus.Done);
      } else {
        this.currentWorkspaceFileUser = null;
        this.workspaceFileUsers = null;
        this.workspaceFiles = null;
        this.truncateEndIndex = undefined;
        this.truncateList = false;
        this.allUsersAreDoneInMoreMenu = false;
      }
    }
  }

  onWorkspaceFileUserStatusClicked(status: WorkspaceFileUserStatus) {
    this.updateWorkspaceFileUserStatus.emit({
      status,
      workspaceFile: this.workspaceFile
    });
  }
}
